export enum StitchIframeMessage {
  AccountAdded = 'account_added',
  ManualReview = 'manual_review',
}
